import styled from "react-emotion";
import { themeGet } from "styled-system";
import { Heading, Text } from "../misc";

// @flex
// @width
// @padding
// @overflow
// @margin
export const Wrapper = styled("div")`
  width: 100%;
  overflow-x: scroll;
  display: flex;
  padding: ${themeGet("space.3")}px;
  margin-bottom: ${themeGet("space.5")}px;
`;

// @flex
// @margin
export const Item = styled("div")`
  flex-basis: 150px;
  flex-shrink: 0;
  flex-grow: 0;

  &:not(:last-child) {
    margin-right: ${themeGet("space.5")}px;
  }

  @media screen and (min-width: 40em) and (max-width: 52em), (min-width: 76em) {
    flex-basis: 180px;
  }
`;

// @flex
export const ItemContent = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

// @letter-spacing
export const DeliveryHeading = styled(Heading)`
  font-size: 14px;
  text-transform: uppercase;
  letter-spacing: 0.1px;
  font-weight: 400;

  @media screen and (min-width: 40em) and (max-width: 52em), (min-width: 76em) {
    font-size: 18px;
  }
`;

export const DeliveryText = styled(Text)`
  font-size: 14px;
  text-align: justify;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  @media screen and (min-width: 40em) and (max-width: 52em), (min-width: 76em) {
    font-size: 16px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/deliverysummary/style.js